export default () => {
    require('./scripts/addToCart');
    require('./scripts/product');
    require('./scripts/productAddToCartPopup');
    require('./scripts/productImagesPopup');
    require('./scripts/productPinchImage');
    require('./scripts/slider');
};
